import { map2Tokens as map2ColorTokens } from './mappers/color';
import { map2Tokens as map2ConstantsTokens } from './mappers/constants';
import { map2Tokens as map2FontFamilyTokens } from './mappers/fontFamily';
import { map2Tokens as map2FontSizeTokens } from './mappers/fontSize';
import { map2Tokens as map2FontWeightTokens } from './mappers/fontWeight';
import { map2Tokens as map2RadiusTokens } from './mappers/radius';
import { map2Tokens as map2SpaceTokens } from './mappers/space';
import { map2Tokens as map2ZIndexTokens } from './mappers/zIndex';
export const convertToTokens = legacyTheme => {
  // Using legacy theme can only customize the light mode
  const tokenJson = {
    ':root': {}
  };
  if (!legacyTheme) {
    return tokenJson;
  }
  const mappedColor = map2ColorTokens(legacyTheme['color']);
  const mappedSpace = map2SpaceTokens(legacyTheme['space']);
  const mappedFontFamily = map2FontFamilyTokens(legacyTheme['font']);
  const mappedFontWeight = map2FontWeightTokens(legacyTheme['font']['primary']['fontWeight']);
  const mappedFontSize = map2FontSizeTokens(legacyTheme['font']['primary']['size']);
  const mappedRadius = map2RadiusTokens(legacyTheme['radius']);
  const mappedZIndex = map2ZIndexTokens(legacyTheme['zIndex']);
  const mappedConstants = map2ConstantsTokens(legacyTheme['constants']);
  tokenJson[':root'] = {
    ...mappedColor,
    ...mappedSpace,
    ...mappedFontFamily,
    ...mappedFontWeight,
    ...mappedFontSize,
    ...mappedRadius,
    ...mappedZIndex,
    ...mappedConstants
  };
  return tokenJson;
};